@if (kedjaKopplingar?.length) {
  <div class="modal-header">
    <h3 class="modal-title" id="modal-title">Hantera åtgärdskedja</h3>
    <button type="button" class="btn-close" (click)="dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 list-wrapper">
        <rask-div-list #atgardKedjeList [data]="kedjaKopplingar" [fixedHeader]="true" key="atgardGuid"
          [rowDrag]="false">
          @if (this.relativaArFeatureActive) {
              <rask-list-column header="Huvudåtgärd" width="100px" [nowrap]="true">
                <ng-template let-row="row">
                    <rask-checkbox
                      [checked]="row.huvudatgard"
                      [disabled]="isAnyHuvudatgardChecked(row) || isAtgardFranAnnatKontrakt(row)"
                      (checkedChange)="setHuvudatgard(row)">
                    </rask-checkbox>
                </ng-template>
              </rask-list-column>
          }
          <rask-list-column header="Beteckning" [nowrap]="true">
            <ng-template let-row="row">
                <span class="vk-text mx-1">{{ row.beteckning }}</span>
            </ng-template>
          </rask-list-column>
          <rask-list-column header="Åtgärdstyp">
            <ng-template let-row="row">
              <span class="vk-text mx-1">{{ row.atgardstyp }}</span>
            </ng-template>
          </rask-list-column>
          @if (relativaArFeatureActive) {
              <rask-list-column header="Relativa år" [nowrap]="true">
                <ng-template let-row="row">
                  <rask-input-number class="relativa-ar"
                    (ngModelChange)="onRelativaArChanged(row)"
                    [(ngModel)]="row.relativaAr"
                    [min]="0"
                    [isNegative]="false"
                    [disabled]="row.huvudatgard || isRelativaArDisabled(row)">
                  </rask-input-number>
                </ng-template>
              </rask-list-column>
          }
          <rask-list-column header="Önskat datum" [nowrap]="true">
            <ng-template let-row="row">
              @if (isSkogsvardsAtgard(row)) {
                  <rask-datepicker
                    [onlyMonths]="true"
                    [(ngModel)]="row.onskatDatum"
                    [disabled]="isOnskatDatumDisabled(row)"
                    [minDate]="minSelectableDate"
                    (ngModelChange)="onOnskatDatumChanged(row)">
                  </rask-datepicker>
              }
            </ng-template>
          </rask-list-column>
          <rask-list-column header="Planeringsstatus" [nowrap]="true">
            <ng-template let-row="row">
                <rask-simple-selector
                    #planeringsstatusSelector
                    (ngModelChange)="onPlaneringsstatusChange(row, planeringsstatusSelector.value)"
                    [values]="getSelectlistItems(row)"
                    bindLabel="value"
                    bindValue="value"
                    [clearable]="false"
                    [disabled]="isSelectorDisabled(row)"
                    [(ngModel)]="row.status">
                </rask-simple-selector>
            </ng-template>
          </rask-list-column>
          <rask-list-column header="Utfört datum" [nowrap]="true">
            <ng-template let-row="row">
                <span class="vk-text mx-1">{{ shortDate(row.utfortDatum ?? row.produktionGodkandDatum) }}</span>
            </ng-template>
          </rask-list-column>
          <rask-list-column width="100px" [nowrap]="true">
            <ng-template let-row="row" let-rowidx="idx">
              @if (rowidx !== 0) {
                <div class="vk-text">
                  <rask-icon-button
                    (click)="moveInList(row, -1)"
                    icon="far fa-chevron-up"
                    [disabled]="kontraktReadonly"
                    label="Upp">
                  </rask-icon-button>
                </div>
              }
              @if (rowidx < kedjaKopplingar.length-1) {
                <div class="vk-text">
                  <rask-icon-button
                    (click)="moveInList(row, 1)"
                    icon="far fa-chevron-down"
                    [disabled]="kontraktReadonly"
                    label="Ned">
                  </rask-icon-button>
                </div>
              }
            </ng-template>
          </rask-list-column>
        </rask-div-list>
      </div>
    </div>
  </div>
  @if ((messageItemsAsObservable | async).length > 0) {
    <div class="validation-panel">
      <rask-message-panel
        [items]="messageItemsAsObservable">
      </rask-message-panel>
    </div>
  }
  <div class="modal-footer">
    <rask-button aid="buttonSpara" color="primary" (click)="save()" [disabled]="!isDirty || kontraktReadonly">Spara</rask-button>
    <rask-button aid="buttonAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus>Avbryt</rask-button>
  </div>
}